import React, { memo } from 'react';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { Status } from 'common/utils/constants';
import '../ActionTwoHopProgressViewModal.css';

const ActionTwoHopPodDevicesDropdownContainer = (props) => {
  return (
    <div
      id="ActionTwoHopProgressViewModal_Header_POD_Devices_Container"
      className="ActionTwoHopProgressViewModal_Header_POD_Devices_Container"
    >
      <div
        id="ActionTwoHopProgressViewModal_Header_POD_Devices_Left"
        className="ActionTwoHopProgressViewModal_Header_POD_Devices_Left"
        title={props.podNameOne ?? 'Unknown'}
      >
        <Dropdown
          mouseover={true}
          hideArrow={false}
          disabled={props.searchTwoHopDevicesStatus !== Status.SUCCESS}
          title={props.podNameOne ?? 'Unknown'}
          data={props.podOneDevices.map((deviceId, idx) => {
            return deviceId ? (
              <IconAndText
                img={idx === 0 ? IconLoader.icon_donor : IconLoader.icon_service}
                hoverImg={idx === 0 ? IconLoader.icon_donor : IconLoader.icon_service}
                text={deviceId}
              />
            ) : null;
          })}
        />
      </div>
      <SvgAF img={IconLoader.icon_black_right_arrow} hover={IconLoader.icon_black_right_arrow} />
      <div
        id="ActionTwoHopProgressViewModal_Header_POD_Devices_Right"
        className="ActionTwoHopProgressViewModal_Header_POD_Devices_Right"
        data-tip={props.podNameTwo ?? 'Unknown'}
      >
        <Dropdown
          mouseover={true}
          hideArrow={false}
          disabled={props.searchTwoHopDevicesStatus !== Status.SUCCESS}
          title={props.podNameTwo ?? 'Unknown'}
          data={props.podTwoDevices.map((deviceId, idx) => {
            return deviceId ? (
              <IconAndText
                img={idx === 0 ? IconLoader.icon_donor : IconLoader.icon_service}
                hoverImg={idx === 0 ? IconLoader.icon_donor : IconLoader.icon_service}
                text={deviceId}
              />
            ) : null;
          })}
        />
      </div>
    </div>
  );
};

export default memo(ActionTwoHopPodDevicesDropdownContainer);
